import React, {useContext} from 'react';
import MobXContext from "../../../app/mobx/MobXContext";
import {observer} from "mobx-react";
import OutputLine from "../Output/OutputLine";
import ENVIRONMENT from "../../../../../../src/js/misc/environment";
import escapeOutputString from "../../../misc/escapeOutputString";
import PropTypes from "prop-types";

const propTypes = {
	baseIndent: PropTypes.number.isRequired,
};
const defaultProps = {};

const hasSetting = configuratorStore => (
	configuratorStore.utahId.authCallback ||
	configuratorStore.utahId.customParams ||
	configuratorStore.utahId.customURL ||
	(configuratorStore.utahId.environment !== ENVIRONMENT.PROD)
);

const ConfiguratorUtahIdPlainOutput = ({baseIndent}) => {
	const {configuratorStore} = useContext(MobXContext);

	return (
		hasSetting(configuratorStore) ? (
			<>
				<OutputLine indent={baseIndent}>
					{`utahId: {`}
				</OutputLine>

				{
					configuratorStore.utahId.authCallback ?
						<OutputLine indent={baseIndent + 1} highlightableField="authCallback">
							{`authCallback: ${configuratorStore.utahId.authCallback},`}
						</OutputLine> :
						undefined
				}

				{
					configuratorStore.utahId.customParams ?
						<OutputLine indent={baseIndent + 1} highlightableField="customParams">
							{`customParams: ['${(configuratorStore.utahId.customParams || '').split(' ').map(escapeOutputString).join("', '")}'],`}
						</OutputLine> :
						undefined
				}

				{
					(configuratorStore.utahId.environment === ENVIRONMENT.CUSTOM && configuratorStore.utahId.customURL) ?
						<OutputLine indent={baseIndent + 1} highlightableField="customURL">
							{`customURL: '${encodeURI(escapeOutputString(configuratorStore.utahId.customURL))}',`}
						</OutputLine> :
						undefined
				}

				{
					// prod is default when url is blank, so no need to set that environment value
					(configuratorStore.utahId.environment && configuratorStore.utahId.environment !== ENVIRONMENT.PROD) ?
						<OutputLine indent={baseIndent + 1} highlightableField="environment">
							{`environment: '${escapeOutputString(configuratorStore.utahId.environment)}',`}
						</OutputLine> :
						undefined
				}

				<OutputLine indent={baseIndent}>
					{`},`}
				</OutputLine>
			</>
		) : (
			<OutputLine indent={baseIndent}>
				{`utahId: true,`}
			</OutputLine>
		)
	);
};

ConfiguratorUtahIdPlainOutput.propTypes = propTypes;
ConfiguratorUtahIdPlainOutput.defaultProps = defaultProps;

export default observer(ConfiguratorUtahIdPlainOutput);
